import RepresentativeList from './RepresentativeList'

export default RepresentativeList
